// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2Kt5Z","title":"styles_title__1_YNB","value":"styles_value__10gzm","name":"styles_name__u10HW"};